import { Component, computed, input } from '@angular/core';
import { QuestionBase } from '@jump-tech-frontend/domain';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'question-hint-popover',
  template: `
    @if (question().hint && !question().permanentHint) {
    <div
      class="survey-popover-trigger"
      [ngbPopover]="popoverContent"
      container="body"
      placement="bottom-right"
      popoverClass="survey-popover"
    >
      <ng-template #popoverContent><div [innerHtml]="question().hint"></div></ng-template>
      <span class="material-icons material-icons-inline">{{ icon() }}</span>
    </div>
    }
  `,
  imports: [NgbPopoverModule]
})
export class QuestionHintPopoverComponent {
  question = input.required<QuestionBase<string>>();
  icon = computed(() => this.question().icon || 'info');
}
